import React, { createRef, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from '../../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    OR_RRF_Select as Select
    , ORFButton as Button
    , OR_RRF_InputField as InputField
} from '../../../../../../common/forms/order-request-form.component';
import { newCircuitExhibitBActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-exhibit-b.reducer";

class WirelineSubscriptionFormB extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.onSubscriptionFormLoad();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {

        const {
            // component props
            onClickCancel
            , prevAction
            , nextAction
            // form
            , wirelineSubscriptionFormB
            // reducer action
            , onVendorSelect
            , onPlanSelect
            , onQuantityChange
        } = this.props;

        const { planOptions
            , preferredVendorOptions
            , vendorDetails
            , primaryPlanDetail} = this.props.newCircuitExhibitBRequest;

        //const requiredValidation = { required: (val) => val && val.length };
        //const vendorValidationErrorMsgs = { required: 'Vendor field is required.' };
        //const planValidationErrorMsgs = { required: 'Plan field is required.' };
        //const simValidationErrorMsgs = { required: 'Plan field is required.' };

        let disable = wirelineSubscriptionFormB.vendorDetailId == 0
            || wirelineSubscriptionFormB.planId == 0
            || wirelineSubscriptionFormB.quantity <= 0;

        return (
            <div >
                <Form method="post" role="form"
                    model="wirelineSubscriptionFormB"
                    //onChange={(otherRequestWirelineForm, event) => onChangeWirelineOtherForm(otherRequestWirelineForm, event)}
                    //onSubmit={(otherRequestWirelineForm, event) => this.handleSubmit(otherRequestWirelineForm, event)}
                    onSubmit={nextAction}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('vendor')} *`}
                                options={preferredVendorOptions}
                                placeholder={this.toLocaleLanguage('select_a_vendor')}
                                fieldProp='.vendorDetailId'
                                value={wirelineSubscriptionFormB.vendorDetailId}
                                onChangeAction={onVendorSelect}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('commodity_code')} *`}
                                options={planOptions}
                                placeholder={this.toLocaleLanguage('select_a_plan')}
                                fieldProp='.planId'
                                value={wirelineSubscriptionFormB.planId}
                                onChangeAction={onPlanSelect}
                            />
                        </Col>
                    </Row>
                    {/* strt */}
                    <div className="price-plan-details-container">
                        <div className="price-plan-left-details">
                            <div className="price-plan-header">
                                <span><Translation translationKey="plan_details" /></span>
                            </div>
                            <div className="price-plan-list">
                                {
                                    primaryPlanDetail.PlanId > 0 ?
                                        <div>
                                            <span>{primaryPlanDetail.ComponentName}</span>
                                            <br />
                                            <span><b>{primaryPlanDetail.ComponentDetails}</b></span>
                                        </div> : <span><Translation translationKey="no_selected_plan" /></span>
                                }
                            </div>
                        </div>

                        <div className="price-plan-right-details">
                            <div className="price-plan-header">
                                <span><Translation translationKey="other_features" /></span>
                            </div>
                        </div>
                    </div>
                    {/* END */}
                    <div className="price-plan-total-cost-container">
                        <div className="price-plan-header">
                            <span><Translation translationKey="estimated_monthly_cost" /></span>
                        </div>
                        <div className="price-plan-total">
                            <span>{vendorDetails.Currency}</span>
                            <span>{primaryPlanDetail.ComponentCost.toFixed(2)}</span>
                        </div>
                    </div>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <InputField
                                className="form-control"
                                type="number"
                                label={`${this.toLocaleLanguage('quantity')} *`}
                                value={wirelineSubscriptionFormB.quantity}
                                fieldProp='.quantity'
                                onChangeAction={onQuantityChange}
                            />
                        </Col>
                    </Row>
                    <div className="price-plan-total-cost-container">
                        <div className="price-plan-header">
                            <span><Translation translationKey="capital_total_cost" /></span>
                        </div>
                        <div className="price-plan-total">
                            <span>{vendorDetails.Currency}</span>
                            <span>{wirelineSubscriptionFormB.totalCost.toFixed(2)}</span>
                        </div>
                    </div>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <Button
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('back')}
                                    variant={"outline-secondary"}
                                    action={prevAction}
                                />
                            </div>
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('next_button')}
                                    variant={"primary"}
                                    type={"submit"}
                                    disabled={disable}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};


export default connect(
    state => {
        const { newCircuitExhibitBRequest, translation } = state;
        const { wirelineSubscriptionFormB } = state.form;
        return {
            newCircuitExhibitBRequest
            , wirelineSubscriptionFormB
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newCircuitExhibitBActions),
            dispatch
        )
)(WirelineSubscriptionFormB);
